<template>
    <form-row title="Have you locked your rate?">
        <input-radio-boolean
            name="have_you_locked_your_rate"
            :value="mortgage.have_you_locked_your_rate"
            true="Yes"
            false="No"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        mortgage: {},
        read_only: { default: false },
    },
}
</script>
